module.exports = __webpack_public_path__ + "fonts/BourgeoisRounded-BoldCondensed.b3e1ab68.woff2";